export const MoviesIcon = () => (
  <span>
    <svg
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      viewBox="0 0 24 24"
    >
      <path d="M4 4h16v16H4z" />
      <path d="M4 8h16" />
      <path d="M8 4l2 4" />
      <path d="M12 4l2 4" />
      <path d="M16 4l2 4" />
    </svg>
  </span>
);
